import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 md:py-20 lg:py-24 px-4 border-t-4 border-gray-700" data-id="element-216">
      <div className="max-w-4xl mx-auto" data-id="element-217">
        <div className="bg-[#1a1a1a] p-12 md:p-16 rounded-lg border-4 border-gray-700 shadow-lg" data-id="element-218">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-10 text-center leading-tight" data-id="element-219">
            Una formación <span className="text-[#c41e3a]" data-id="element-220">profesional</span>,
            no un curso improvisado
          </h2>
          <div className="w-24 h-1 bg-[#c41e3a] mx-auto mb-10" data-id="element-221"></div>
          <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed text-center mb-8" data-id="element-222">
            Esta formación está basada en un método estructurado que te enseña a
            analizar, decidir y ejecutar cortes con criterio profesional.
          </p>
          <p className="text-2xl md:text-3xl text-gray-200 font-black text-center" data-id="element-223">
            No se trata de copiar técnicas, sino de entender el proceso
            completo.
          </p>
        </div>
      </div>
    </section>;
}